const SvelteSet = globalThis.Set;
const SvelteURLSearchParams = globalThis.URLSearchParams;
export {
  SvelteSet as S,
  SvelteURLSearchParams as a
};
